import { EquipmentCard } from "../catalog/EquipmentCard";
import { usePublicCategory } from "../catalog/api";
import type { TypeSummary } from "../catalog/types";

// "You might also need…" — up to three sibling cards from the same
// category as the cart's first item, excluding everything already in
// the cart. The audit flagged the dead area below the line items as a
// missed upsell opportunity; this rail fills it without inventing fake
// content.
export interface CartCrossSellRailProps {
  cartTypes: TypeSummary[];
  limit?: number;
}

export function CartCrossSellRail({
  cartTypes,
  limit = 3,
}: CartCrossSellRailProps): JSX.Element | null {
  const anchor = cartTypes[0];
  const { data } = usePublicCategory(anchor?.category.slug ?? null);

  if (!anchor || !data) return null;

  const cartIds = new Set(cartTypes.map((t) => t.id));
  const candidates = data.types.filter((t) => !cartIds.has(t.id)).slice(0, limit);
  if (candidates.length === 0) return null;

  return (
    <section
      aria-labelledby="cart-cross-sell-heading"
      className="mt-10 border-t border-zinc-200 pt-8"
    >
      <div className="flex items-end justify-between gap-3">
        <div>
          <h2
            id="cart-cross-sell-heading"
            className="font-serif text-xl font-bold italic tracking-tight text-brand-black md:text-2xl"
          >
            You might also need
          </h2>
          <span aria-hidden="true" className="mt-2 inline-block h-0.5 w-10 bg-brand-red" />
        </div>
      </div>
      <ul className="mt-4 grid gap-4 sm:grid-cols-2 md:grid-cols-3">
        {candidates.map((sib) => (
          <li key={sib.id}>
            <EquipmentCard type={sib} categorySlug={anchor.category.slug} />
          </li>
        ))}
      </ul>
    </section>
  );
}
